# class Delegator
#   delegate(@, 'map', 'forEach', 'find', to: 'entityMap')
export delegate = (cls, methodNames..., options) ->
  methodNames.forEach (name) =>
    cls::[name] = (args...) ->
      receiver = @[options.to]
      receiver[name].apply(receiver, args)

# class Delegator
#   wrap(@, 'where', 'orderBy', around: 'entityMap', wrapperMethod: '_withMap')
export wrap = (cls, methodNames..., options) ->
  methodNames.forEach (name) =>
    cls::[name] = (args...) ->
      receiver = @[options.around]
      @[options.wrapperMethod](receiver[name].apply(receiver, args))
